module.exports = __webpack_public_path__ + "img/s4Model.e290d6a9.png";